import React, { useState } from 'react';
import { useSnackbar } from 'notistack';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Autocomplete, CircularProgress, Grid, TextField, Box } from '@mui/material';
import { approvalStatus } from '.';
import { claimStatusUpdateApi, getClaimTimelineApi, getShopVisitStatusTimelineApi, shopVisitstatusUpdateApi } from '../apiServices';
import { globalGetService, globalPostService } from '../../../utils/globalApiServices';
import { checkApiStatus, } from '../../../utils';
import { PageLoader } from '../../../shared_elements';
import { AttachementsUpload, ButtonLoader } from '../../../shared_elements/components';
import { trackActivity } from '../../../utils/mixpanel';
import { useDispatch, useSelector } from 'react-redux';
import { setFileUploadDetails } from '../../../shared_elements/actions';
import { formatBytes } from '../../../utils/fileUpload';

const StatusChangeModal = ({ params, modalData, shopVisit, toggleModalFn, getResponseBack, pageTitle, fileUpload }) => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState({ pageLoader: false, buttonLoader: false });
    const toggleLoader = (type, status) => setLoading({ [type]: status })
    const { enqueueSnackbar } = useSnackbar();
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [statusData, setStatusData] = useState({});
    const [error, setError] = useState({});
    const { storageDetails } = useSelector((state) => state.leases);

    const onApprovalStatusChange = () => {
        let validationInputs = {};
        validationInputs = {
            status: !statusData?.status ? "Please select Status" : "",
            remarks: !statusData?.remarks ? "Please enter Remarks" : ""
        };
        if (Object.keys(validationInputs).every((k) => { return validationInputs[k] === ""; })) {
            let updatedPayload
            const isWorkscopeReview = shopVisit?.status?.value === 2;
            if (statusData?.status?.value === 1) {
                updatedPayload = { status: isWorkscopeReview ? 5 : 3 };
            } else if (statusData?.status?.value === 2) {
                updatedPayload = { status: isWorkscopeReview ? 6 : 4 };
            }
            if (statusData?.status?.value === 1) {
                updatedPayload = { ...updatedPayload,lease_slug: params?.leaseSlug, comment: statusData?.remarks, claim_approval_period: statusData?.claim_approval_period ? statusData?.claim_approval_period : null }
            } else updatedPayload = { ...updatedPayload,lease_slug: params?.leaseSlug, reason_for_rejection: statusData?.remarks, claim_approval_period: null }
            toggleLoader("buttonLoader", true)
            globalPostService(pageTitle==="Claim" ? claimStatusUpdateApi(params,modalData?.data?.slug) : shopVisitstatusUpdateApi(shopVisit?.slug), updatedPayload)
                .then(async(response) => {
                    if (checkApiStatus(response)) {
                        const timelineResponse= await globalGetService(pageTitle==="Claim" ? getClaimTimelineApi(params,response?.data?.data?.slug): getShopVisitStatusTimelineApi(response?.data?.data?.slug))
                        if (uploadedFiles?.length > 0 && timelineResponse?.data?.data[0]?.slug) {
                            fileUpload(timelineResponse?.data?.data[0]?.slug, 'created', pageTitle === "Claim" ? 'claim_status_history' : 'shop_visit_status_history')
                        }
                        toggleLoader("buttonLoader", false)
                        toggleModalFn()
                        getResponseBack()
                        setStatusData()
                        enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Item Added', { page_title: `Add Shop Visit Status`, success_msg: response?.data?.message, item_id: response?.data?.data?.id, payload: updatedPayload, response: response?.data })
                    } else {
                        enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
                        trackActivity('Item Added', { page_title: `Add Shop Visit Status`, error_msg: response?.data?.message, item_id: null, payload: updatedPayload, response: response?.data })
                    }
                })
        } else {
            setError(validationInputs)
            trackActivity(`Item Added`, { page_title: `Change Status`, error_msg: validationInputs, })
        }
    }
    const onFieldChange = (key, value) => { setStatusData({ ...statusData, [key]: value }) }
    const onFocusChange = (key) => { setError({ ...error, [key]: "" }) }
    const handleFileChange = (files) => { setUploadedFiles(files); dispatch(setFileUploadDetails({ attachments: files })) }
    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Shop Visit Status Change`, page_type: page_type, })
    }
    return (
        <>
            {isLoading?.pageLoader ? <PageLoader /> :
                <Dialog
                    open={modalData?.statusModal}
                     aria-labelledby="customized-dialog-title"
                    className='add-lease-dialog'
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle id="scroll-dialog-title" sx={{ m: 0, p: 2 }} className='dialog-header'>Change Status</DialogTitle>
                    <DialogContent dividers={true} sx={{ p: 2 }}>
                        <Grid container spacing={2}>
                            <Grid size={{ md: 6, xs: 12 }}>
                                <Autocomplete
                                    disablePortal
                                    disableClearable
                                    options={approvalStatus}
                                    getOptionLabel={(option) => option.label || ""}
                                    // value={shopVisit?.status || null}
                                    isOptionEqualToValue={(option, value) => option.value === value.value}
                                    onChange={(e, value) => { onFieldChange("status", value); }}
                                    onFocus={() => onFocusChange("status")}
                                    renderInput={(params) => (
                                        <TextField
                                            required
                                            {...params}
                                            label="Status"
                                            margin='normal'
                                            size='small'
                                            error={Boolean(error?.status)}
                                            helperText={error?.status}
                                            slotProps={{ inputLabel: { shrink: true } }}
                                            disabled={isLoading?.buttonLoader}
                                            onFocus={() => onFocusChange("status")}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <TextField
                                required
                                    id="remarks"
                                    label="Remarks"
                                    variant="outlined"
                                    size='small'
                                    margin='normal'
                                    slotProps={{ inputLabel: { shrink: true } }}
                                    fullWidth
                                    multiline
                                    rows={3}
                                    error={Boolean(error?.remarks)}
                                    helperText={error?.remarks}
                                    onChange={(e) => onFieldChange("remarks", e.target.value)}
                                    disabled={isLoading?.buttonLoader}
                                    onFocus={() => onFocusChange("remarks")}
                                />
                            </Grid>
                            <Grid size={{ md: 12, xs: 12 }}>
                                <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                                    <Button className='available-space-btn' disableRipple size='small' variant='outlined' color='primary' endIcon={isLoading?.storage ? <ButtonLoader size={15} /> : null}>{`Available Space : ${isLoading?.storage ? "" : formatBytes(storageDetails?.remaining_storage)}`}</Button>
                                </Box>
                                <AttachementsUpload onFileChange={handleFileChange} docError={error.attachments} attachments={statusData?.attachments} remainingStorage={storageDetails?.remaining_storage} />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <div>
                            <div style={{ float: 'right' }}>
                                <Button className="cancel-btn" onClick={() => { toggleModalFn(); handleItemClicked('Cancel Button') }} color="primary" variant='outlined' sx={{ marginRight: "5px" }} size="small">Cancel</Button>
                                <Button variant="contained" onClick={() => { handleItemClicked('Save Button'); onApprovalStatusChange() }} color="primary" size="small">
                                    {isLoading?.buttonLoader ? <CircularProgress color="#ffffff" size={24} /> : 'Save'}
                                </Button>
                            </div>
                        </div>
                    </DialogActions>
                </Dialog>}
        </>
    )
}
export default StatusChangeModal;


